import { Stack, Typography } from "@mui/joy";
import { findSubstringIndices } from "logic/logics";
import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";

export default function Keypoints() {
  const { t: t_payment } = useTranslation("translation", {
    keyPrefix: "payment",
  });

  const userState = useRecoilValue(userAtom);
  const isAiCoachProduct = userState?.isAiCoachProduct;

  return (
    <Stack
      spacing={0.5}
      sx={{
        borderRadius: "12px",
        px: "20px",
        py: "16px",
        backgroundColor: "card.background",
      }}
    >
      {[
        // {
        //   text: t_payment("부담없는 월별 결제"),
        //   boldText: t_payment("월별 결제"),
        // },
        {
          text: t_payment("체계적인 인지치료 프로그램"),
          boldText: t_payment("체계적인 인지치료"),
        },
        {
          text: t_payment(
            `정신건강 전문 ${
              isAiCoachProduct ? "AI 코치" : "코치 선생님"
            }의 리딩`
          ),
          boldText: t_payment(
            isAiCoachProduct ? "전문 AI 코치" : "전문 코치 선생님"
          ),
        },
        {
          text: t_payment("스스로 우울증을 해결하는 지속가능한 관리 도구"),
          boldText: t_payment("지속가능한 관리 도구"),
        },
      ].map(({ text, boldText }, index) => (
        <Typography
          key={`keypoint${index}`}
          startDecorator={
            <span
              style={{ fontSize: "20px" }}
              className="material-symbols-rounded"
            >
              done
            </span>
          }
        >
          <div>
            {[
              text.substring(
                0,
                findSubstringIndices(text, boldText).startIndex
              ),
              boldText,
              text.substring(findSubstringIndices(text, boldText).endIndex + 1),
            ].map((each) =>
              each === boldText ? (
                <b key={each}>{each}</b>
              ) : (
                <span key={each}>{each}</span>
              )
            )}
          </div>
        </Typography>
      ))}
    </Stack>
  );
}
